export default "__VITE_PUBLIC_ASSET__1ca7ea76__"